import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset } from "rbx";
import { useMutation } from "react-apollo";

import { EditFormButtonGroup } from "../inputs";

import {
  UPDATE_ITEM_CATEGORY_MUTATION,
  DELETE_ITEM_CATEGORY_MUTATION
} from "../../graphql/ItemCategories/ItemCategories.graphql";

import { ourToast as toast } from "../../utils";

import ItemForm from "./ItemCategoryForm";

const DEFAULT_STATE = {
  Active: true,
  Description: "",
  ItemCatgCd: "",
  InspectionCdRecIdRef: null,
  ItemCatgTypeRecIdRef: null
};

const EditItemCategory = ({ itemCategory, onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (
      e.target.name.includes("InspectionCdRecIdRef") ||
      e.target.name.includes("ItemCatgTypeRecIdRef")
    ) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };
  useEffect(() => {
    if (itemCategory) {
      setInputs(prev => ({ ...prev, ...itemCategory }));
    }
  }, [itemCategory]);
  const [updateItemCategory, { loading }] = useMutation(
    UPDATE_ITEM_CATEGORY_MUTATION,
    {
      refetchQueries: [
        "ALL_ITEM_CATEGORIES_QUERY",
        "SINGLE_ITEM_CATEGORY_QUERY"
      ]
    }
  );
  const handleSave = async e => {
    e.preventDefault();
    try {
      const data = Object.keys(DEFAULT_STATE).reduce(
        (acc, curr) => ({
          ...acc,
          [curr]: inputs[curr]
        }),
        {}
      );
      await updateItemCategory({
        variables: {
          data: {
            ...data,
            InspectionCdRecIdRef:
              inputs.InspectionCdRecIdRef &&
              parseInt(inputs.InspectionCdRecIdRef),
            ItemCatgTypeRecIdRef:
              inputs.ItemCatgTypeRecIdRef &&
              parseInt(inputs.ItemCatgTypeRecIdRef)
          },
          where: {
            RecId: parseInt(inputs.RecId)
          }
        }
      });
      toast.success("Item category created successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error creating Item Category.");
    }
  };
  return (
    <form
      className="edit-item-form"
      id="edit-item-category-form"
      onSubmit={handleSave}
    >
      <Title>Edit Item Category</Title>
      <Fieldset disabled={loading}>
        <ItemForm inputs={inputs} onChange={handleChange} />
        <EditFormButtonGroup
          deleteMutation={DELETE_ITEM_CATEGORY_MUTATION}
          form="edit-item-category-form"
          refetchQueries={["ALL_ITEM_CATEGORIES_QUERY"]}
          variables={{ where: { RecId: parseInt(inputs.RecId) } }}
          onComplete={onComplete}
        />
      </Fieldset>
    </form>
  );
};

EditItemCategory.propTypes = {
  itemCategory: PropTypes.object,
  onComplete: PropTypes.func
};
export default EditItemCategory;
